/* TCGSUPPLY Binder — storefront behaviour */
(() => {
  const theme = window.theme || { routes: {} };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const debounce = (fn, ms) => {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const format = theme.money || '${{amount}}';
    const value = Number(cents) / 100;
    const withDelims = (n, decimals, thousands, decimal) => {
      const [whole, frac] = n.toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  /* ---------- Toast ---------- */
  function toast(message, isError = false) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.toggle('toast--error', isError);
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.hidden = true; }, 3800);
  }

  /* ---------- Dialogs ---------- */
  function openDialog(id, opener) {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    dialog._opener = opener || document.activeElement;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (id === 'SearchDialog') {
      const input = $('[data-predictive-input]', dialog);
      if (input) setTimeout(() => input.focus(), 30);
    }
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openDialog(opener.dataset.open, opener);
      return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
      return;
    }
    if (e.target.tagName === 'DIALOG' && e.target.open) e.target.close();
  });
  $$('dialog').forEach(watchDialog);
  function watchDialog(dialog) {
    dialog.addEventListener('close', () => {
      if (!$$('dialog').some((d) => d.open)) document.documentElement.style.overflow = '';
      if (dialog._opener && document.contains(dialog._opener)) dialog._opener.focus();
    });
  }

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-stuck', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  const navDetails = $$('[data-nav-details]');
  navDetails.forEach((d) => {
    d.addEventListener('toggle', () => {
      if (d.open) navDetails.forEach((o) => { if (o !== d) o.open = false; });
    });
  });
  document.addEventListener('click', (e) => {
    navDetails.forEach((d) => { if (d.open && !d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    navDetails.forEach((d) => {
      if (d.open) { d.open = false; $('summary', d).focus(); }
    });
  });

  /* ---------- Cart ---------- */
  const cartToggle = $('[data-cart-toggle]');
  if (cartToggle) {
    cartToggle.addEventListener('click', (e) => {
      if (theme.cartType === 'page' || !document.getElementById('CartDrawer')) return;
      e.preventDefault();
      openDialog('CartDrawer', cartToggle);
    });
  }

  function cartSectionIds() {
    const ids = ['cart-drawer'];
    const page = $('[data-cart-page]');
    const wrapper = page && page.closest('.shopify-section');
    if (wrapper) ids.push(wrapper.id.replace('shopify-section-', ''));
    return ids;
  }

  function renderSections(sections) {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        const fresh = $('[data-cart-drawer-inner]', doc);
        const current = $('[data-cart-drawer-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      } else {
        const target = document.getElementById(`shopify-section-${id}`);
        const fresh = doc.getElementById(`shopify-section-${id}`) || doc.body.firstElementChild;
        if (target && fresh) target.innerHTML = fresh.innerHTML;
      }
    });
  }

  async function refreshCount() {
    try {
      const res = await fetch(`${theme.routes.cart}.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      return cart;
    } catch (err) {
      return null;
    }
  }

  function bumpCount() {
    $$('[data-cart-count]').forEach((el) => {
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
  }

  function flySticker(source) {
    const target = $('[data-cart-toggle]');
    if (!source || !target || reduceMotion) return Promise.resolve();
    const from = source.getBoundingClientRect();
    const to = target.getBoundingClientRect();
    if (!from.width || !to.width) return Promise.resolve();
    const clone = source.cloneNode(true);
    clone.classList.add('fly-sticker');
    clone.setAttribute('aria-hidden', 'true');
    Object.assign(clone.style, { left: `${from.left}px`, top: `${from.top}px`, width: `${from.width}px` });
    document.body.appendChild(clone);
    const dx = to.left + to.width / 2 - (from.left + from.width / 2);
    const dy = to.top + to.height / 2 - (from.top + from.height / 2);
    const anim = clone.animate(
      [
        { transform: 'translate(0, 0) rotate(-3deg) scale(1)', opacity: 1 },
        { transform: `translate(${dx * 0.45}px, ${dy * 0.45 - 60}px) rotate(8deg) scale(0.85)`, opacity: 1, offset: 0.45 },
        { transform: `translate(${dx}px, ${dy}px) rotate(-6deg) scale(0.3)`, opacity: 0.4 }
      ],
      { duration: 680, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
    );
    return anim.finished.then(() => clone.remove()).catch(() => clone.remove());
  }

  async function addToCart(form) {
    const button = $('[type="submit"]', form);
    const errorBox = $('[data-form-error]', form);
    if (errorBox) errorBox.hidden = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    const body = new FormData(form);
    body.append('sections', cartSectionIds().join(','));
    body.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        const message = data.description || data.message || 'That could not be added. Please try again.';
        if (errorBox) { errorBox.textContent = message; errorBox.hidden = false; } else toast(message, true);
        return;
      }
      if (theme.cartType === 'page') {
        window.location.href = theme.routes.cart;
        return;
      }
      renderSections(data.sections);
      const scope = form.closest('.pocket') || form.closest('[data-product]') || document;
      const sticker = $('[data-sticker]', scope);
      await flySticker(sticker);
      await refreshCount();
      bumpCount();
      openDialog('CartDrawer', button);
    } catch (err) {
      toast('Connection problem. Please try again.', true);
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('.js-add, .js-product-form')) return;
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    addToCart(form);
  });

  async function changeLine(key, quantity) {
    const containers = $$('[data-cart-drawer-inner], [data-cart-page]');
    containers.forEach((c) => c.setAttribute('aria-busy', 'true'));
    try {
      const res = await fetch(`${theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity), sections: cartSectionIds(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        toast(data.description || data.message || 'That change could not be saved.', true);
        return;
      }
      renderSections(data.sections);
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = data.item_count;
        el.hidden = data.item_count === 0;
      });
    } catch (err) {
      toast('Connection problem. Please try again.', true);
    } finally {
      $$('[data-cart-drawer-inner], [data-cart-page]').forEach((c) => c.removeAttribute('aria-busy'));
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.dataset.lineKey, parseInt(btn.dataset.cartQty, 10));
  });
  const onCartInput = debounce((input) => changeLine(input.dataset.lineKey, parseInt(input.value || '0', 10)), 450);
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-cart-input]')) onCartInput(e.target);
  });

  /* ---------- Quantity steppers (product) ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = $('input', step.closest('[data-qty]'));
    const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
    input.value = next;
  });

  /* ---------- Predictive search ---------- */
  const predictiveInput = $('[data-predictive-input]');
  const predictiveResults = $('[data-predictive-results]');
  if (predictiveInput && predictiveResults) {
    let controller;
    const search = debounce(async (term) => {
      if (controller) controller.abort();
      if (term.length < 2) {
        predictiveResults.innerHTML = '';
        predictiveInput.setAttribute('aria-expanded', 'false');
        return;
      }
      controller = new AbortController();
      try {
        const url = `${theme.routes.predictiveSearch}?q=${encodeURIComponent(term)}&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last&section_id=predictive-search`;
        const res = await fetch(url, { signal: controller.signal });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('.shopify-section') || doc.body;
        predictiveResults.innerHTML = section.innerHTML;
        predictiveInput.setAttribute('aria-expanded', 'true');
      } catch (err) {
        if (err.name !== 'AbortError') predictiveResults.innerHTML = '';
      }
    }, 220);
    predictiveInput.addEventListener('input', () => search(predictiveInput.value.trim()));
  }

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach((gallery) => {
    const slides = $('[data-gallery-slides]', gallery);
    const thumbs = $$('[data-thumb]', gallery);
    if (!slides || thumbs.length === 0) return;
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const slide = $(`[data-media-id="${thumb.dataset.thumb}"]`, slides);
        if (slide) slides.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
          const id = entry.target.dataset.mediaId;
          thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumb === id)));
        }
      });
    }, { root: slides, threshold: [0.6] });
    $$('[data-media-id]', slides).forEach((s) => io.observe(s));
  });

  /* ---------- Variant picker ---------- */
  $$('[data-product]').forEach((product) => {
    const form = $('.js-product-form', product);
    const json = $('[data-variants]', product);
    if (!form || !json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = $('[data-variant-id]', form);
    const button = $('[data-add-button]', form);
    const sticky = $('[data-sticky-buy] .btn');
    product.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option]')) return;
      const selected = $$('fieldset', form).map((fs) => {
        const checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
      const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
      if (!variant) {
        button.disabled = true;
        button.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.label : 'Sold out';
      if (sticky) {
        sticky.disabled = !variant.available;
      }
      $$('[data-sticker]').forEach((sticker) => {
        const price = $('.sticker__price', sticker);
        if (price) price.textContent = formatMoney(variant.price);
        let was = $('.sticker__was', sticker);
        if (variant.compare_at_price > variant.price) {
          if (!was) {
            was = document.createElement('span');
            was.className = 'sticker__was';
            sticker.prepend(was);
          }
          was.textContent = formatMoney(variant.compare_at_price);
        } else if (was) was.remove();
        sticker.classList.toggle('sticker--sold', !variant.available);
      });
      const sku = $('[data-sku]', product);
      if (sku) sku.textContent = variant.sku || '';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });

  /* ---------- Sticky buy bar ---------- */
  const stickyBuy = $('[data-sticky-buy]');
  const mainButton = $('[data-add-button]');
  if (stickyBuy && mainButton && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyBuy.classList.toggle('is-visible', past);
      stickyBuy.setAttribute('aria-hidden', String(!past));
      const btn = $('.btn', stickyBuy);
      if (btn) btn.tabIndex = past ? 0 : -1;
    });
    io.observe(mainButton);
  }

  /* ---------- Filters & sort ---------- */
  $$('[data-facets-form]').forEach((form) => {
    if (form.id !== 'FacetsDesktop') return;
    const submit = () => {
      const params = new URLSearchParams(new FormData(form));
      for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
      window.location.href = `${form.action}?${params.toString()}`;
    };
    const submitSoon = debounce(submit, 700);
    form.addEventListener('change', (e) => {
      if (e.target.type === 'number') submitSoon(); else submit();
    });
  });
  $$('[data-facets-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const params = new URLSearchParams(new FormData(form));
      for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
      window.location.href = `${form.action}?${params.toString()}`;
    });
  });
  $$('[data-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Delivery estimate ---------- */
  // Handling: 1–2 business days from the order (after 2:00 pm MT or on a weekend, the clock starts
  // the next business day). US transit: 2–5 business days. Pre-orders ship on the release date.
  $$('[data-eta]').forEach((eta) => {
    if (eta.dataset.available === 'false') { eta.hidden = true; return; }
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Denver', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23'
    }).formatToParts(new Date()).map((p) => [p.type, p.value]));
    const today = new Date(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
    const isBD = (d) => d.getDay() !== 0 && d.getDay() !== 6;
    const addBD = (d, n) => { const r = new Date(d); let left = n; while (left > 0) { r.setDate(r.getDate() + 1); if (isBD(r)) left--; } return r; };
    const nextBD = (d) => { const r = new Date(d); while (!isBD(r)) r.setDate(r.getDate() + 1); return r; };
    const fmt = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const range = (a, b) => {
      if (a.getTime() === b.getTime()) return fmt(a);
      return a.getMonth() === b.getMonth() ? `${fmt(a)}–${b.getDate()}` : `${fmt(a)} – ${fmt(b)}`;
    };
    let shipMin, shipMax;
    const rel = eta.dataset.release ? new Date(`${eta.dataset.release}T12:00:00`) : null;
    if (eta.dataset.pre === 'true' && rel && rel > today) {
      shipMin = nextBD(new Date(rel.getFullYear(), rel.getMonth(), rel.getDate()));
      shipMax = addBD(shipMin, 1);
    } else {
      const beforeCutoff = isBD(today) && Number(parts.hour) < 14;
      const handlingStarts = beforeCutoff ? today : addBD(today, 1);
      shipMin = addBD(handlingStarts, 1);
      shipMax = addBD(handlingStarts, 2);
    }
    const arriveMin = addBD(shipMin, 2);
    const arriveMax = addBD(shipMax, 5);
    const set = (sel, text) => { const el = $(sel, eta); if (el) el.textContent = text; };
    set('[data-eta-order]', fmt(today));
    set('[data-eta-ship]', eta.dataset.pre === 'true' && rel && rel > today ? fmt(shipMin) : range(shipMin, shipMax));
    set('[data-eta-arrive]', range(arriveMin, arriveMax));
  });

  /* ---------- Release-day row ---------- */
  $$('[data-release-track]').forEach((track) => {
    const nav = $('[data-release-nav]', track.closest('.releases'));
    const buttons = nav ? $$('[data-release-step]', nav) : [];
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 4;
      const atEnd = track.scrollLeft >= max;
      track.classList.toggle('is-end', atEnd);
      buttons.forEach((b) => {
        b.disabled = b.dataset.releaseStep === '-1' ? track.scrollLeft <= 4 : atEnd;
      });
      if (nav) nav.hidden = track.scrollWidth <= track.clientWidth + 4;
    };
    buttons.forEach((b) => b.addEventListener('click', () => {
      track.scrollBy({ left: Number(b.dataset.releaseStep) * track.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
    }));
    track.addEventListener('scroll', debounce(update, 60), { passive: true });
    window.addEventListener('resize', debounce(update, 150));
    update();
  });

  /* ---------- Recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (err) { /* leave empty */ }
  });

  /* ---------- Address forms ---------- */
  $$('select[data-default]').forEach((select) => {
    if (select.dataset.default) select.value = select.dataset.default;
  });
})();
